import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { AgendaModule } from '../agenda/agenda.module';
import { AgendaPageComponent } from './agenda-page.component';
import { AgendaComponent } from '../agenda/agenda.component';
import { AgendaPageRoutingModule } from './agenda-page-routing.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ActividadesService } from '../../providers/actividades.service';
import { ActividadesModule } from '../actividades/actividades.module';

@NgModule({
  declarations: [
    AgendaPageComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AgendaModule,
    AgendaPageRoutingModule,
    ActividadesModule
  ],
  exports: [
  ],
  providers: [
    DatePipe,
    ActividadesService
  ]
})
export class AgendaPageModule { }
